/** @file useEditorStore: the store object itself, for actions and `getState()` in event handlers. */
import { useContext } from 'react';
import { EditorStoreContext } from './editorStoreContext';
import type { EditorStore } from './editorTypes';

/** The store from context; throws outside an `EditorStoreContext.Provider`. */
export function useEditorStore(): EditorStore {
  const store = useContext(EditorStoreContext);
  if (store === null) throw new Error('useEditorStore: no EditorStoreContext.Provider above this component');
  return store;
}
